<template>
  <div id="app">
    <header class="sticky-header">
      <div class="header-content">
        <h1 class="main-title">
          Fretboard Tool <span class="version">V2</span>
        </h1>
        <div class="rightside-content">
          <InstrumentSelector />
        </div>
      </div>
    </header>

    <div class="main-container">
      <div class="fretboard-container">
        <FretboardDisplay />
      </div>
      <div class="bottom-settings">
        <FretboardSettings />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FretboardDisplay from "@/components/FretboardDisplay.vue";
import FretboardSettings from "@/components/FretboardSettings.vue";
import InstrumentSelector from "@/components/InstrumentSelector.vue";
import { onMounted } from "vue";
import { useFretboardStore } from "@/stores/fretboard";

const store = useFretboardStore();

onMounted(() => {
  // Ensure the store has an initial scale set
  if (!store.selectedScaleName) {
    store.setSelectedScale("major");
  }
});
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: transparent;
  z-index: 1000;
}

.header-content {
  max-width: calc(100% - 160px);
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Header responsive breakpoints matching main container */
/* Large screens: Reduce margins, keep padding */
@media (max-width: 1200px) {
  .header-content {
    max-width: calc(100% - 80px);
    padding: 16px 24px;
  }
}

/* Medium screens: Minimal margins, reduce padding */
@media (max-width: 900px) {
  .header-content {
    max-width: calc(100% - 32px);
    padding: 16px 16px;
  }
}

/* Small screens: Minimal margins, minimal padding */
@media (max-width: 640px) {
  .header-content {
    max-width: calc(100% - 16px);
    padding: 16px 8px;
  }
}

.rightside-content {
  display: flex;
  gap: 20px;
}

.main-title {
  margin: 0;
  font-size: 24px;
  color: var(--shade-70);
}

.version {
  font-size: 14px;
  color: var(--shade-50);
}
</style>
